import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';


type FieldTypes = 'date' | 'string';

@Component({
  selector: 'gen-uploaded-file-details',
  templateUrl: './uploaded-file-details.component.html',
  styleUrls: ['./uploaded-file-details.component.scss']
})
export class UploadedFileDetailsComponent implements OnInit {
  @Output() click: EventEmitter<Event> = new EventEmitter();
  @Input() fileFields: Array<{ label: string, value: string | number, type?: FieldTypes }>;
  @Input() warningImageUrl: any;
  @Input() deleteFileCallback: any;
  @Input() disabled = false;
  readonly warningText = 'Deviation in PCR protocol is detected, please consider that this might lead to inaccurate results. Please consult the executing technician or the OncoSignal team.';

  constructor() {
  }

  ngOnInit() {

  }

  deleteFile($event) {
    this.click.emit($event)
    this.deleteFileCallback($event);
  }

}
